module.exports = "<listado-general \r\n  [listado]=\"sistemas\" \r\n  [titulo]=\"'Sistemas'\"\r\n  [leyendaListado]=\"'DEFAULT_LEYENDA_HOME' | translate\"\r\n  (clickNuevo)=\"navegarNuevoSistema()\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/configuracion.component.html
// module id = ../../../../../src/app/private/configuracion/configuracion.component.html
// module chunks = main